import BusinessDetails from "./BusinessDetails";
export default BusinessDetails;
